'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _sliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/slice');
var _Array$from = require('@babel/runtime-corejs3/core-js-stable/array/from');
var _Symbol = require('@babel/runtime-corejs3/core-js-stable/symbol');
var _getIteratorMethod = require('@babel/runtime-corejs3/core-js/get-iterator-method');
var _Array$isArray = require('@babel/runtime-corejs3/core-js-stable/array/is-array');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _Map = require('@babel/runtime-corejs3/core-js-stable/map');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _Object$keys = require('@babel/runtime-corejs3/core-js-stable/object/keys');
var _indexOfInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/index-of');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _JSON$stringify = require('@babel/runtime-corejs3/core-js-stable/json/stringify');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _findInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/find');
var _Set = require('@babel/runtime-corejs3/core-js-stable/set');
var _fillInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/fill');
var _spliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/splice');
require('../error/index.js');
require('../utils/index.js');
var gsqlLoadingJob_interface = require('./gsql-loading-job.interface.js');
var dataSet_interface = require('./data-set.interface.js');
var graphStudioError_model = require('../error/graph-studio-error.model.js');
var helperFunctions = require('../utils/helper-functions.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _sliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_sliceInstanceProperty);
var _Array$from__default = /*#__PURE__*/_interopDefaultLegacy(_Array$from);
var _Symbol__default = /*#__PURE__*/_interopDefaultLegacy(_Symbol);
var _getIteratorMethod__default = /*#__PURE__*/_interopDefaultLegacy(_getIteratorMethod);
var _Array$isArray__default = /*#__PURE__*/_interopDefaultLegacy(_Array$isArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _Map__default = /*#__PURE__*/_interopDefaultLegacy(_Map);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _Object$keys__default = /*#__PURE__*/_interopDefaultLegacy(_Object$keys);
var _indexOfInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_indexOfInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _JSON$stringify__default = /*#__PURE__*/_interopDefaultLegacy(_JSON$stringify);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _findInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_findInstanceProperty);
var _Set__default = /*#__PURE__*/_interopDefaultLegacy(_Set);
var _fillInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_fillInstanceProperty);
var _spliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_spliceInstanceProperty);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol__default["default"] && _getIteratorMethod__default["default"](r) || r["@@iterator"]; if (!t) { if (_Array$isArray__default["default"](r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context32; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty__default["default"](_context32 = {}.toString.call(r)).call(_context32, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from__default["default"](r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/**
 * Describing the data source type of each single loading item.
 * - DataSourceColumn: one column in column-wise parsed data source
 * - TokenFunction: a token function
 * - Map: a map
 * - Tuple: a UDT
 * - Default: use default value
 * - Literal: use string literal
 * - ...
 *
 * @export
 * @enum {number}
 */
var SourceType = /*#__PURE__*/function (SourceType) {
  SourceType[SourceType["DataSourceColumn"] = 0] = "DataSourceColumn";
  SourceType[SourceType["MappingWidget"] = 1] = "MappingWidget";
  SourceType[SourceType["Default"] = 2] = "Default";
  SourceType[SourceType["Literal"] = 3] = "Literal";
  return SourceType;
}({});

/**
 * One column mapping source of DataSourceColumn type.
 * - type: SourceType.DataSourceColumn
 * - columnIndex: index of data source column
 *
 * @export
 * @interface OneColumnMappingDataSourceColumnSource
 */

/**
 * One column mapping source of TokenFunction type.
 * - type: SourceType.MappingWidget
 * - mappingWidgetIndex: index of mapping widget array
 *
 * @export
 * @interface OneColumnMappingMappingWidgetSource
 */

/**
 * Describing one column mapping's target type.
 * - GraphEntity: vertex primary id, edge source | target vertex, attributes
 * - MappingWidget: mapping widget parameter
 *
 * @export
 * @enum {number}
 */
var OneColumnMappingTargetType = /*#__PURE__*/function (OneColumnMappingTargetType) {
  OneColumnMappingTargetType[OneColumnMappingTargetType["GraphEntity"] = 0] = "GraphEntity";
  OneColumnMappingTargetType[OneColumnMappingTargetType["MappingWidget"] = 1] = "MappingWidget";
  return OneColumnMappingTargetType;
}({}); // In the future, might support json_flatten_array, reduce function, split, etc.

/**
 * One column mapping target of graph entity type.
 * - type: OneColumnMappingTargetType.GraphEntity
 * - mappingIndex: index of mapping array
 *
 * @export
 * @interface OneColumnMappingTarget
 */

/**
 * One column mapping target of mapping widget type.
 * - type: OneColumnMappingTargetType.MapingWidget
 * - mappingWidgetIndex: index of mapping widget array
 * - paramIndex: index of the mapping widget's parameter array
 *
 * @export
 * @interface OneColumnMappingTokenFunctionTarget
 */

/**
 * Describes loading mapping of one mapping widget.
 * - params: the loading source for each parameter of the mapping widget.
 *
 * @export
 * @interface MappingWidget
 */

/**
 * Describes loading mapping of one token function.
 * - funcName: token function's name, like gsql_concat, gsql_to_epoch, etc
 *
 * @export
 * @interface TokenFunction
 */

/**
 * Describes loading mapping of one Map widget.
 * - keyType: map key data type, INT, STRING, etc
 * - valType: map val data type, INT, STRING, udt name, etc
 *
 * @export
 * @interface MapWidget
 * @extends {MappingWidget}
 */

/**
 * Describes loading mapping of one UDT widget.
 * - udtName: the udt name.
 * - udt: the UDT.
 *
 * @export
 * @interface TupleWidget
 * @extends {MappingWidget}
 */

/**
 * Describes loading mapping of one user defined token function.
 * - name: token function's name, like gsql_concat, gsql_to_epoch, etc
 * - returnType: return type of function
 * - paramNumber: number of parameters taken (undefined means any amount)
 * - paramNumberFixed: if parameter number is predetermined
 * - doc: includes the description and samples
 * - code: actual implementation of token function
 *
 * @export
 * @interface TokenFunctionSignature
 */

/**
 * Describes loading mapping of one user defined token function in GSQL response.
 * - name: token function's name, like gsql_concat, gsql_to_epoch, etc
 * - returnType: return type of function
 * - code: actual implementation of token function
 * - paramNumber: number of parameters taken (undefined means any amount)
 *
 * @export
 * @interface GSQLTokenFunction
 */

// Combination of builtin and user defined token functions
var combinedTokenFunctionList = [];

// Supported token functions
var builtinTokenFunctionNames = ['gsql_concat', 'gsql_reverse', 'gsql_to_bool', 'gsql_to_int', 'gsql_to_uint', 'gsql_current_time_epoch', 'gsql_ts_to_epoch_seconds', 'gsql_is_true', 'gsql_is_false', 'gsql_is_not_empty_string', 'gsql_token_equal', 'gsql_token_ignore_case_equal', 'gsql_upper', 'gsql_lower', 'gsql_trim', 'gsql_ltrim', 'gsql_rtrim', 'gsql_year', 'gsql_month', 'gsql_day', 'gsql_year_epoch', 'gsql_month_epoch', 'gsql_day_epoch', 'gsql_find', 'gsql_length', 'gsql_replace', 'gsql_regex_match', 'gsql_regex_replace', 'gsql_substring', 'gsql_uuid_v4'];

// Each token function's compatible attribute types
var stringTypeList = ['STRING', 'STRING COMPRESS'];
var intTypeList = ['INT'];
var uintTypeList = ['UINT'];
var boolTypeList = ['BOOL'];
var builtinTokenFunctionReturnType = new _Map__default["default"]([['gsql_concat', stringTypeList], ['gsql_reverse', stringTypeList], ['gsql_to_bool', boolTypeList], ['gsql_to_int', intTypeList], ['gsql_to_uint', uintTypeList], ['gsql_current_time_epoch', uintTypeList], ['gsql_ts_to_epoch_seconds', uintTypeList], ['gsql_is_true', boolTypeList], ['gsql_is_false', boolTypeList], ['gsql_is_not_empty_string', boolTypeList], ['gsql_token_equal', boolTypeList], ['gsql_token_ignore_case_equal', boolTypeList], ['gsql_upper', stringTypeList], ['gsql_lower', stringTypeList], ['gsql_trim', stringTypeList], ['gsql_ltrim', stringTypeList], ['gsql_rtrim', stringTypeList], ['gsql_year', intTypeList], ['gsql_month', intTypeList], ['gsql_day', intTypeList], ['gsql_year_epoch', intTypeList], ['gsql_month_epoch', intTypeList], ['gsql_day_epoch', intTypeList], ['gsql_find', intTypeList], ['gsql_length', uintTypeList], ['gsql_replace', stringTypeList], ['gsql_regex_match', boolTypeList], ['gsql_regex_replace', stringTypeList], ['gsql_substring', stringTypeList], ['gsql_uuid_v4', stringTypeList]]);

// Each token function's parameter number, undefined means user can specify any number of params
var builtinTokenFunctionParamNumber = new _Map__default["default"]([['gsql_concat', undefined], ['gsql_reverse', 1], ['gsql_to_bool', 1], ['gsql_to_int', 1], ['gsql_to_uint', 1], ['gsql_current_time_epoch', 1], ['gsql_ts_to_epoch_seconds', 1], ['gsql_is_true', 1], ['gsql_is_false', 1], ['gsql_is_not_empty_string', 1], ['gsql_token_equal', 2], ['gsql_token_ignore_case_equal', 2], ['gsql_upper', 1], ['gsql_lower', 1], ['gsql_trim', 1], ['gsql_ltrim', 1], ['gsql_rtrim', 1], ['gsql_year', 1], ['gsql_month', 1], ['gsql_day', 1], ['gsql_year_epoch', 1], ['gsql_month_epoch', 1], ['gsql_day_epoch', 1], ['gsql_find', 2], ['gsql_length', 1], ['gsql_replace', 4], ['gsql_regex_match', 2], ['gsql_regex_replace', 3], ['gsql_substring', 3], ['gsql_uuid_v4', 1]]);

// Each token function's description, sample input and sample output
var builtinTokenFunctionDocument = new _Map__default["default"]([['gsql_concat', {
  description: 'Returns a string which is the concatenation of all the input strings. ' + 'User need specify how many strings he/she wants to concatenate.',
  samples: [{
    sampleInput: ['Kevin', '#', 'US'],
    sampleOutput: '"Kevin#US"'
  }]
}], ['gsql_reverse', {
  description: 'Returns a string with the characters in the reverse order of the input string.',
  samples: [{
    sampleInput: ['Kevin'],
    sampleOutput: '"niveK"'
  }]
}], ['gsql_to_bool', {
  description: 'Returns true if the input is either "t" or "true", with case insensitive ' + 'checking. Returns false otherwise.',
  samples: [{
    sampleInput: ['True'],
    sampleOutput: 'true'
  }, {
    sampleInput: ['t'],
    sampleOutput: 'true'
  }, {
    sampleInput: ['F'],
    sampleOutput: 'false'
  }]
}], ['gsql_to_int', {
  description: 'If input is the string representation of an int, the function returns ' + 'that integer. If input is the string representation of a float, the function returns ' + 'that number cast as an int.',
  samples: [{
    sampleInput: ['4'],
    sampleOutput: '4'
  }, {
    sampleInput: ['-5'],
    sampleOutput: '-5'
  }, {
    sampleInput: ['4.2'],
    sampleOutput: '4'
  }]
}], ['gsql_to_uint', {
  description: 'If input is the string representation of an unsigned int, the function returns ' + 'that integer. If input is the string representation of a nonnegative float, the function ' + 'returns that number cast as an unsigned int.',
  samples: [{
    sampleInput: ['4'],
    sampleOutput: '4'
  }, {
    sampleInput: ['4.2'],
    sampleOutput: '4'
  }]
}], ['gsql_current_time_epoch', {
  description: 'Returns the current time in Unix epoch seconds.',
  samples: [{
    sampleInput: [],
    sampleOutput: '1500336217'
  }]
}], ['gsql_ts_to_epoch_seconds', {
  description: 'Converts a timestamp in canonical string format to Unix epoch time, which is ' + 'the int number of seconds since Jan. 1, 1970. The main_string should be in one of ' + 'the following 3 formats:\n"%Y-%m-%d %H:%M:%S"\n"%Y/%m/%d %H:%M:%S"\n"%Y-%m-%dT%H:%M:%S.000z"' + '  // text after . is ignored',
  samples: [{
    sampleInput: ['2017-07-17 12:30:13'],
    sampleOutput: '1500294613'
  }]
}], ['gsql_is_true', {
  description: 'Returns true if input is either "t" or "true" (case insensitive). ' + 'Returns false otherwise.',
  samples: [{
    sampleInput: ['T'],
    sampleOutput: 'true'
  }, {
    sampleInput: ['True'],
    sampleOutput: 'true'
  }]
}], ['gsql_is_false', {
  description: 'Returns true if input is either "f" or "false" (case insensitive). ' + 'Returns false otherwise.',
  samples: [{
    sampleInput: ['F'],
    sampleOutput: 'false'
  }, {
    sampleInput: ['False'],
    sampleOutput: 'false'
  }]
}], ['gsql_is_not_empty_string', {
  description: 'Returns true if input is not empty after removing white space. ' + 'Returns false otherwise.',
  samples: [{
    sampleInput: [''],
    sampleOutput: 'false'
  }, {
    sampleInput: [' Something'],
    sampleOutput: 'true'
  }]
}], ['gsql_token_equal', {
  description: 'Returns true if 1st input is exactly the same (case sensitive) as 2nd input. ' + 'Returns false otherwise.',
  samples: [{
    sampleInput: ['abc', 'abc'],
    sampleOutput: 'true'
  }, {
    sampleInput: ['Abc', 'abc'],
    sampleOutput: 'false'
  }, {
    sampleInput: ['a', 'b'],
    sampleOutput: 'false'
  }]
}], ['gsql_token_ignore_case_equal', {
  description: 'Returns true if 1st input is exactly the same (case insensitive) as 2nd input. ' + 'Returns false otherwise.',
  samples: [{
    sampleInput: ['abc', 'abc'],
    sampleOutput: 'true'
  }, {
    sampleInput: ['Abc', 'abc'],
    sampleOutput: 'true'
  }, {
    sampleInput: ['a', 'b'],
    sampleOutput: 'false'
  }]
}], ['gsql_upper', {
  description: 'Converts a string to all uppercase letters.',
  samples: [{
    sampleInput: ['Hello World!'],
    sampleOutput: '"HELLO WORLD!"'
  }]
}], ['gsql_lower', {
  description: 'Converts a string to all lowercase letters.',
  samples: [{
    sampleInput: ['Hello World!'],
    sampleOutput: '"hello world!"'
  }]
}], ['gsql_trim', {
  description: 'Trims whitespace and table characters of both sides of the string.',
  samples: [{
    sampleInput: ['  Hello World!  '],
    sampleOutput: '"Hello World!"'
  }]
}], ['gsql_ltrim', {
  description: 'Trims heading whitespace and table characters of the string.',
  samples: [{
    sampleInput: ['  Hello World!  '],
    sampleOutput: '"Hello World!"  '
  }]
}], ['gsql_rtrim', {
  description: 'Trims tailing whitespace and table characters of the string.',
  samples: [{
    sampleInput: ['  Hello World!  '],
    sampleOutput: '  "Hello World!"'
  }]
}], ['gsql_year', {
  description: 'Returns 4-digit year from timestamp.',
  samples: [{
    sampleInput: ['2010-02-14 15:32:10'],
    sampleOutput: '2010'
  }]
}], ['gsql_month', {
  description: 'Returns month (1-12) from timestamp.',
  samples: [{
    sampleInput: ['2010-02-14 15:32:10'],
    sampleOutput: '2'
  }]
}], ['gsql_day', {
  description: 'Returns day (1-31) from timestamp.',
  samples: [{
    sampleInput: ['2010-02-14 15:32:10'],
    sampleOutput: '14'
  }]
}], ['gsql_year_epoch', {
  description: 'Returns 4-digit year from epoch.',
  samples: [{
    sampleInput: ['1266190330'],
    sampleOutput: '2010'
  }]
}], ['gsql_month_epoch', {
  description: 'Returns month (1-12) from epoch.',
  samples: [{
    sampleInput: ['1266190330'],
    sampleOutput: '2'
  }]
}], ['gsql_day_epoch', {
  description: 'Returns day (1-31) from epoch.',
  samples: [{
    sampleInput: ['1266190330'],
    sampleOutput: '14'
  }]
}], ['gsql_find', {
  description: 'Returns the start index of the first occurrence of the specified substring ' + 'within the input string, or -1 if the substring is not found.',
  samples: [{
    sampleInput: ['State:CA', 'CA'],
    sampleOutput: '6'
  }, {
    sampleInput: ['State:AZ', 'CA'],
    sampleOutput: '-1'
  }]
}], ['gsql_length', {
  description: 'Returns the length of the input string.',
  samples: [{
    sampleInput: ['Kevin'],
    sampleOutput: '5'
  }]
}], ['gsql_replace', {
  description: 'Returns the resulting string when the specified max number of occurrences of the ' + 'specified old token in the input string are replaced with the specified new token.',
  samples: [{
    sampleInput: ['TigergraphDB is a graph-based DBMS.', 'graph', 'Graph', '1'],
    sampleOutput: '"TigerGraphDB is a graph-based DBMS."'
  }]
}], ['gsql_regex_match', {
  description: 'Returns true if the given string token matches the given regular expression token ' + 'and false otherwise.',
  samples: [{
    sampleInput: ['Kevin', '[A-Z][a-z]+'],
    sampleOutput: 'true'
  }, {
    sampleInput: ['Kevin', '[0-9]+'],
    sampleOutput: 'false'
  }]
}], ['gsql_regex_replace', {
  description: 'Returns the resulting string by replacing all substrings in the input string ' + 'that match the given regular expression token with the given substitute string.',
  samples: [{
    sampleInput: ['1,12,123,1234', '[0-9]+', 'number'],
    sampleOutput: '"number,number,number,number"'
  }]
}], ['gsql_substring', {
  description: 'Returns a substring of the input string starting at the specified index ' + 'with the specified length.',
  samples: [{
    sampleInput: ['State:CA', '6', '2'],
    sampleOutput: '"CA"'
  }]
}], ['gsql_uuid_v4', {
  description: 'Generates a random Version 4 UUID and returns it.',
  samples: [{
    sampleInput: [''],
    sampleOutput: '"4493d5ce-a69b-4c90-88e4-b41e9f576169"'
  }]
}]]);

/**
 * Loading mapping of one column.
 * - sourceType: one column from data source | token function | default | literal
 * - index: used if sourceType is one column from data source or token function
 * - literal: used if sourceType is literal
 *
 * @export
 * @interface OneColumnMapping
 */

/**
 * Loading mapping related logic.
 *
 * @export
 * @class LoadingMappingLogic
 */
var LoadingMappingLogic = /*#__PURE__*/function () {
  function LoadingMappingLogic() {
    _classCallCheck__default["default"](this, LoadingMappingLogic);
  }
  return _createClass__default["default"](LoadingMappingLogic, null, [{
    key: "validationCheck",
    value:
    /**
     * Check that the one column mapping is consisted by supported mapping types:
     * - SrcColIndex, Literal, Default, UDF
     *
     * @static
     * @param {GSQLLoadingAstJson} oneColumnMapping
     * @returns {{
     *     success: boolean,
     *     message?: string
     *   }}
     * @memberof LoadingMappingLogic
     */
    function validationCheck(oneColumnMapping) {
      // 1. Not supported type
      if (!_includesInstanceProperty__default["default"](gsqlLoadingJob_interface.supportedLoadingMappingTypes).call(gsqlLoadingJob_interface.supportedLoadingMappingTypes, oneColumnMapping.Type)) {
        return {
          success: false,
          message: "\"".concat(oneColumnMapping.Type, "\" is not supported in Graph Studio.")
        };
      }

      // 2. Supported types but contains advanced information
      for (var _i = 0, _Object$keys = _Object$keys__default["default"](oneColumnMapping); _i < _Object$keys.length; _i++) {
        var propName = _Object$keys[_i];
        if (!_includesInstanceProperty__default["default"](gsqlLoadingJob_interface.SUPPORTED_PROPNAMES).call(gsqlLoadingJob_interface.SUPPORTED_PROPNAMES, propName)) {
          return {
            success: false,
            message: "\"".concat(propName, "\" is not supported in Graph Studio.")
          };
        }
      }

      // 3. Token function recursively check the parameter
      if (oneColumnMapping.Type === 'UDF') {
        var parameters = oneColumnMapping.Params;
        var _iterator = _createForOfIteratorHelper(parameters),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var param = _step.value;
            var validationCheckParam = LoadingMappingLogic.validationCheck(param);
            if (!validationCheckParam.success) {
              return validationCheckParam;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      // 4. Map recursively check the parameter
      if (oneColumnMapping.Type === 'KvPair') {
        var kvPair = oneColumnMapping;
        for (var _i2 = 0, _arr = [kvPair.Key, kvPair.Value]; _i2 < _arr.length; _i2++) {
          var _param = _arr[_i2];
          var _validationCheckParam = LoadingMappingLogic.validationCheck(_param);
          if (!_validationCheckParam.success) {
            return _validationCheckParam;
          }
        }
      }

      // 5. UDT recursively check the parameter
      if (oneColumnMapping.Type === 'UDT') {
        var _parameters = oneColumnMapping.Fields;
        var _iterator2 = _createForOfIteratorHelper(_parameters),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _param2 = _step2.value;
            var _validationCheckParam2 = LoadingMappingLogic.validationCheck(_param2);
            if (!_validationCheckParam2.success) {
              return _validationCheckParam2;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      // success
      return {
        success: true
      };
    }

    /**
     * Recursively build the loading mapping.
     * Depending on mapping type, build the mapping into the mapping container.
     * Also, flatten the token functions into the token function container in DFS order.
     * The token function order will be used as index for the mappings input from the token functions.
     *
     * @static
     * @param {GSQLLoadingAstJson} oneColumnMappingAst the mapping target in GSQL loading ast format
     * @param {OneColumnMapping[]} mappingContainer the container to hold result in-memory mappings
     * @param {((TokenFunction | MapWidget | TupleWidget)[])} mappingWidgetContainer the container
     * to hold UDFs in DFS order
     * @param {DataFieldSchema[]} dataSchema the mapping source data schema
     * @returns
     * @memberof LoadToVertexLogic
     */
  }, {
    key: "loadMappingFromGSQLMappingJson",
    value: function loadMappingFromGSQLMappingJson(oneColumnMappingAst, mappingContainer, mappingWidgetContainer, dataSchema) {
      var _context;
      switch (oneColumnMappingAst.Type) {
        // Put one default mapping
        case 'Default':
          {
            mappingContainer.push({
              sourceType: SourceType.Default
            });
            return;
          }
        // Put one literal mapping
        case 'Literal':
          {
            var gsqlLiteral = oneColumnMappingAst;
            mappingContainer.push({
              sourceType: SourceType.Literal,
              literal: gsqlLiteral.Value
            });
            return;
          }
        // Put one data source column index mapping
        case 'SrcColIndex':
          var gsqlSrcColIndex = oneColumnMappingAst;
          mappingContainer.push({
            sourceType: SourceType.DataSourceColumn,
            index: gsqlSrcColIndex.Value
          });
          break;
        case 'SrcColName':
          var gsqlSrcColName = oneColumnMappingAst;
          /*
            Sample input
            gsqlSrcColName: GSQLSrcColNameJson = {
              Type: 'SrcColName',
              Value: 'a',
              SrcKeyNames: [
                'a',
                'b'
              ],
            }
            dataSchema: DataFieldSchema[] = [
              {
                name: 'a',
                type: JSONDataType.Object,
                level: 0,
                path: [
                  'a'
                ]
              },
              {
                name: 'b',
                type: JSONDataType.String,
                level: 1,
                path: [
                  'a',
                  'b'
                ]
              },
            ]
             Sample output
            index = 1
           */
          mappingContainer.push({
            sourceType: SourceType.DataSourceColumn,
            index: _indexOfInstanceProperty__default["default"](_context = _mapInstanceProperty__default["default"](dataSchema).call(dataSchema, function (dataFieldSchema) {
              return _JSON$stringify__default["default"](dataFieldSchema.path);
            })).call(_context, _JSON$stringify__default["default"](gsqlSrcColName.SrcKeyNames))
          });
          break;
        // Put one UDF mapping
        case 'UDF':
          {
            var gsqlTokenFunction = oneColumnMappingAst;
            // Create the token function
            var tokenFunction = {
              funcName: gsqlTokenFunction.UdfName,
              params: []
            };

            // Add the token function into the mapping widget container
            mappingWidgetContainer.push(tokenFunction);

            // Add the mapping into the mappingContainer
            mappingContainer.push({
              sourceType: SourceType.MappingWidget,
              index: mappingWidgetContainer.length - 1
            });

            // Recursively build the token function's parameters mapping
            var _iterator3 = _createForOfIteratorHelper(gsqlTokenFunction.Params),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var oneColumnMapping = _step3.value;
                LoadingMappingLogic.loadMappingFromGSQLMappingJson(oneColumnMapping, tokenFunction.params, mappingWidgetContainer, dataSchema);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            return;
          }
        // Put one Map mapping
        case 'KvPair':
          {
            var gsqlKVPair = oneColumnMappingAst;
            // Create the Map widget. Here the keyType and valType are not assigned.
            // They will be assigned from the vertex or edge attributes directly.
            var mapWidget = {
              keyType: undefined,
              valType: undefined,
              udtType: undefined,
              params: []
            };

            // Add the Map widget into the mapping widget container
            mappingWidgetContainer.push(mapWidget);

            // Add the Map widget into the mappingContainer
            mappingContainer.push({
              sourceType: SourceType.MappingWidget,
              index: mappingWidgetContainer.length - 1
            });

            // Build the map's key and value mapping
            LoadingMappingLogic.loadMappingFromGSQLMappingJson(gsqlKVPair.Key, mapWidget.params, mappingWidgetContainer, dataSchema);
            LoadingMappingLogic.loadMappingFromGSQLMappingJson(gsqlKVPair.Value, mapWidget.params, mappingWidgetContainer, dataSchema);
            return;
          }
        // Put one UDT mapping
        case 'UDT':
          {
            var gsqlUDT = oneColumnMappingAst;
            // Create the Tuple widget. Here the fieldTypes is not assigned.
            // It will be filled in from the UDT list.
            var tupleWidget = {
              udtName: gsqlUDT.UdtName,
              udt: undefined,
              params: []
            };

            // Add the Tuple widget into the mapping widget container
            mappingWidgetContainer.push(tupleWidget);

            // Add the UDT widget into the mappingContainer
            mappingContainer.push({
              sourceType: SourceType.MappingWidget,
              index: mappingWidgetContainer.length - 1
            });

            // Recursively build the map's parameters mapping
            var _iterator4 = _createForOfIteratorHelper(gsqlUDT.Fields),
              _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var _oneColumnMapping = _step4.value;
                LoadingMappingLogic.loadMappingFromGSQLMappingJson(_oneColumnMapping, tupleWidget.params, mappingWidgetContainer, dataSchema);
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
            return;
          }
      }
    }

    /**
     * Dump in-memory loading mapping to GSQL loading mapping.
     *
     * @static
     * @param {GSQLLoadingAstJson[]} gsqlMappingsContainer
     * @param {OneColumnMapping} oneMapping
     * @param {((TokenFunction | MapWidget | TupleWidget)[])} mappingWidgets
     * @param {DBLoadingStatementStyle} loadingJobStyle
     * @param {DBPositionStyle[]} middlePositionsContainer
     * @param {DataFormat} dataFormat the mapping source data format
     * @param {DataFieldSchema[]} dataSchema the mapping source data schema
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "dumpToGSQLLoadingMapping",
    value: function dumpToGSQLLoadingMapping(gsqlMappingsContainer, oneMapping, mappingWidgets, loadingJobStyle, middlePositionsContainer, dataFormat, dataSchema) {
      switch (oneMapping.sourceType) {
        // Default
        case SourceType.Default:
          {
            var gsqlOneMapping = {
              Type: 'Default'
            };
            gsqlMappingsContainer.push(gsqlOneMapping);
            break;
          }
        // Literal
        case SourceType.Literal:
          {
            var _gsqlOneMapping = {
              Type: 'Literal',
              Value: oneMapping.literal
            };
            gsqlMappingsContainer.push(_gsqlOneMapping);
            break;
          }
        // DataSourceColumn
        case SourceType.DataSourceColumn:
          {
            var _gsqlOneMapping2;
            switch (dataFormat) {
              case dataSet_interface.DataFormat.CSV:
                _gsqlOneMapping2 = {
                  Type: 'SrcColIndex',
                  Value: oneMapping.index
                };
                break;
              case dataSet_interface.DataFormat.JSON:
                var jsonSchema = dataSchema[oneMapping.index];
                _gsqlOneMapping2 = {
                  Type: 'SrcColName',
                  Value: jsonSchema.path[0],
                  SrcKeyNames: jsonSchema.path
                };
                break;
              default:
                // TODO: Support more data formats in the future.
                break;
            }
            gsqlMappingsContainer.push(_gsqlOneMapping2);
            break;
          }
        // UDF
        case SourceType.MappingWidget:
          {
            if ('funcName' in mappingWidgets[oneMapping.index]) {
              var _context2;
              // Token function.
              var _gsqlOneMapping3 = {
                Type: 'UDF',
                UdfName: mappingWidgets[oneMapping.index].funcName,
                Params: []
              };
              // Collect the token function position in DFS order
              middlePositionsContainer.push(loadingJobStyle.middlePositions[oneMapping.index]);
              _forEachInstanceProperty__default["default"](_context2 = mappingWidgets[oneMapping.index].params).call(_context2, function (param) {
                LoadingMappingLogic.dumpToGSQLLoadingMapping(_gsqlOneMapping3.Params, param, mappingWidgets, loadingJobStyle, middlePositionsContainer, dataFormat, dataSchema);
              });
              gsqlMappingsContainer.push(_gsqlOneMapping3);
            } else if ('udtName' in mappingWidgets[oneMapping.index]) {
              var _context3;
              // Tuple
              var _gsqlOneMapping4 = {
                Type: 'UDT',
                UdtName: mappingWidgets[oneMapping.index].udtName,
                Fields: []
              };
              // Collect the Tuple widget position in DFS order
              middlePositionsContainer.push(loadingJobStyle.middlePositions[oneMapping.index]);
              _forEachInstanceProperty__default["default"](_context3 = mappingWidgets[oneMapping.index].params).call(_context3, function (param) {
                LoadingMappingLogic.dumpToGSQLLoadingMapping(_gsqlOneMapping4.Fields, param, mappingWidgets, loadingJobStyle, middlePositionsContainer, dataFormat, dataSchema);
              });
              gsqlMappingsContainer.push(_gsqlOneMapping4);
            } else if ('keyType' in mappingWidgets[oneMapping.index]) {
              var _context4;
              var _gsqlOneMapping5 = {
                Type: 'KvPair',
                Key: undefined,
                Value: undefined
              };
              // Collect the Map widget position in DFS order
              middlePositionsContainer.push(loadingJobStyle.middlePositions[oneMapping.index]);
              var tempContainer = [];
              _forEachInstanceProperty__default["default"](_context4 = mappingWidgets[oneMapping.index].params).call(_context4, function (param) {
                LoadingMappingLogic.dumpToGSQLLoadingMapping(tempContainer, param, mappingWidgets, loadingJobStyle, middlePositionsContainer, dataFormat, dataSchema);
              });
              _gsqlOneMapping5.Key = tempContainer[0];
              _gsqlOneMapping5.Value = tempContainer[1];
              gsqlMappingsContainer.push(_gsqlOneMapping5);
            }
            break;
          }
      }
    }

    /**
     * Map from one column in data source to one column in vertex | edge.
     * Assumptions:
     * 1. srcColIndex is within data source column array boundary
     * 2. mappingsIndex is within vertex | edge mapping array index boundary
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {DataFormat} dataFormat
     * @param {DataFieldSchema[]} dataSchema
     * @param {number} srcColIndex
     * @param {number} mappingsIndex
     * @param {Graph} schema
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "mapDataSourceToEntity",
    value: function mapDataSourceToEntity(loadToEntity, dataFormat, dataSchema, srcColIndex, mappingsIndex, schema) {
      var _context5;
      switch (dataFormat) {
        case dataSet_interface.DataFormat.CSV:
          var vertexOrEdgeType;
          var graphEntityType;
          var attrName;
          var attrType;
          var attrValueType;
          if ('vertexName' in loadToEntity && mappingsIndex > 0) {
            var vertex = schema.getVertex(loadToEntity.vertexName);
            vertexOrEdgeType = vertex.name;
            graphEntityType = 'Vertex';
            attrName = vertex.attributes[mappingsIndex - 1].name;
            attrType = vertex.attributes[mappingsIndex - 1].type.name;
            attrValueType = vertex.attributes[mappingsIndex - 1].type.getValueType();
          } else if ('edgeName' in loadToEntity && mappingsIndex > 1) {
            var edge = schema.getEdge(loadToEntity.edgeName);
            vertexOrEdgeType = edge.name;
            graphEntityType = 'Edge';
            attrName = edge.attributes[mappingsIndex - 2].name;
            attrType = edge.attributes[mappingsIndex - 2].type.name;
            attrValueType = edge.attributes[mappingsIndex - 2].type.getValueType();
          }

          // Blocks map data to MAP and UDT type attributes or attributes included UDT type value.
          if (attrType && _includesInstanceProperty__default["default"](_context5 = ['MAP', 'UDT']).call(_context5, attrType)) {
            var _context6;
            throw new graphStudioError_model.GraphStudioError(_concatInstanceProperty__default["default"](_context6 = "".concat(graphEntityType, " \"")).call(_context6, vertexOrEdgeType, "\"'s attribute ") + "\"".concat(attrName, "\" expects ") + "a(n) ".concat(attrValueType, ",") + " the given input should be from a ".concat(attrValueType, " widget."));
          }
          break;
        case dataSet_interface.DataFormat.JSON:
          var jsonDatatype = dataSchema[srcColIndex].type;
          if ('vertexName' in loadToEntity) {
            // Load to vertex
            var _vertex = schema.getVertex(loadToEntity.vertexName);
            if (mappingsIndex === 0 && !this.jsonAndGSQLTypeMatchCheck(jsonDatatype, _vertex.primaryId.type.getValueType())) {
              // primary id data type not match
              throw new graphStudioError_model.GraphStudioError(this.updateDataSourceToEntityMappingErrorMessage(jsonDatatype, "Vertex \"".concat(_vertex.name, "\"'s primary id expects ") + "a(n) ".concat(_vertex.primaryId.type.getValueType(), ",") + " but the given input type is ".concat(jsonDatatype, ".")));
            } else if (mappingsIndex > 0 && !this.jsonAndGSQLTypeMatchCheck(jsonDatatype, _vertex.attributes[mappingsIndex - 1].type.getValueType())) {
              // attribute data type not match
              throw new graphStudioError_model.GraphStudioError(this.updateDataSourceToEntityMappingErrorMessage(jsonDatatype, "Vertex \"".concat(_vertex.name, "\"'s attribute ") + "\"".concat(_vertex.attributes[mappingsIndex - 1].name, "\" expects ") + "a(n) ".concat(_vertex.attributes[mappingsIndex - 1].type.getValueType(), ",") + " but the given input type is ".concat(jsonDatatype, ".")));
            }
          } else /* if ('edgeName' in loadToEntity) */{
              // Load to edge
              var _edge = schema.getEdge(loadToEntity.edgeName);
              var fromVertex = schema.getVertex(loadToEntity.fromVertexType);
              var toVertex = schema.getVertex(loadToEntity.toVertexType);
              if (mappingsIndex === 0 && !this.jsonAndGSQLTypeMatchCheck(jsonDatatype, fromVertex.primaryId.type.getValueType())) {
                var _context7;
                // source vertex primary id not match
                throw new graphStudioError_model.GraphStudioError(this.updateDataSourceToEntityMappingErrorMessage(jsonDatatype, _concatInstanceProperty__default["default"](_context7 = "Edge \"".concat(_edge.name, "\"'s source vertex \"")).call(_context7, fromVertex.name, "\"'s primary id ") + "expects a(n) ".concat(fromVertex.primaryId.type.getValueType(), ",") + " but the given input type is ".concat(jsonDatatype, ".")));
              } else if (mappingsIndex === 1 && !this.jsonAndGSQLTypeMatchCheck(jsonDatatype, toVertex.primaryId.type.getValueType())) {
                var _context8;
                // target vertex primary id not match
                throw new graphStudioError_model.GraphStudioError(this.updateDataSourceToEntityMappingErrorMessage(jsonDatatype, _concatInstanceProperty__default["default"](_context8 = "Edge \"".concat(_edge.name, "\"'s target vertex \"")).call(_context8, toVertex.name, "\"'s ") + "primary id expects a(n) ".concat(toVertex.primaryId.type.getValueType(), ",") + " but the given input type is ".concat(jsonDatatype, ".")));
              } else if (mappingsIndex > 1 && !this.jsonAndGSQLTypeMatchCheck(jsonDatatype, _edge.attributes[mappingsIndex - 2].type.getValueType())) {
                // attribute data type not match
                throw new graphStudioError_model.GraphStudioError(this.updateDataSourceToEntityMappingErrorMessage(jsonDatatype, "Edge \"".concat(_edge.name, "\"'s attribute ") + "\"".concat(_edge.attributes[mappingsIndex - 2].name, "\" expects ") + "a(n) ".concat(_edge.attributes[mappingsIndex - 2].type.getValueType()) + " but the given input type is ".concat(jsonDatatype, ".")));
              }
            }
          break;
      }
      loadToEntity.mappings[mappingsIndex] = {
        sourceType: SourceType.DataSourceColumn,
        index: srcColIndex
      };
    }

    /**
     * Check if the json input data type matches the GSQL data type in graph entity.
     *
     * @static
     * @private
     * @param {JSONDataType} jsonType
     * @param {string} gsqlType
     * @returns {boolean}
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "jsonAndGSQLTypeMatchCheck",
    value: function jsonAndGSQLTypeMatchCheck(jsonType, gsqlType) {
      switch (jsonType) {
        case dataSet_interface.JSONDataType.String:
          return true;
        case dataSet_interface.JSONDataType.Number:
        case dataSet_interface.JSONDataType.Integer:
          return gsqlType === 'FLOAT' || gsqlType === 'DOUBLE' || gsqlType === 'INT' || gsqlType === 'UINT';
        case dataSet_interface.JSONDataType.Boolean:
          return gsqlType === 'BOOL';
        default:
          return false;
      }
    }

    /**
     * Return error message based on json data type.
     *
     * @static
     * @private
     * @param {JSONDataType} jsonType
     * @param {string} msg
     * @returns {string}
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "updateDataSourceToEntityMappingErrorMessage",
    value: function updateDataSourceToEntityMappingErrorMessage(jsonType, msg) {
      switch (jsonType) {
        case dataSet_interface.JSONDataType.String:
        case dataSet_interface.JSONDataType.Number:
        case dataSet_interface.JSONDataType.Integer:
        case dataSet_interface.JSONDataType.Boolean:
          return msg;
        case dataSet_interface.JSONDataType.Array:
          return "Data mapping from a JSON array to a graph entity " + "attribute is currently not supported in TigerGraph.";
        case dataSet_interface.JSONDataType.Object:
          return "Data mapping directly from a JSON object to a graph entity attribute is not allowed." + " Please map from its descendant primitive (STRING, NUMBER, BOOLEAN, etc) properties instead.";
        case dataSet_interface.JSONDataType.Null:
          return "Data mapping from a JSON null to a graph entity attribute is not allowed.";
      }
    }

    /**
     * Map from one column in data source to one input param in mapping widget.
     * Assumptions:
     * 1. srcColIndex is within data source column array boundary
     * 2. mappingWidgetIndex is within tokenFunctions array index boundary
     * 3. mappingWidgetParamIndex is within the token function's int param array boundary
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {DataFormat} dataFormat
     * @param {DataFieldSchema[]} dataSchema
     * @param {number} srcColIndex  column index of data source
     * @param {number} mappingWidgetIndex mapping widget index in token function array
     * @param {number} mappingWidgetParamIndex mapping target index in mapping widget params
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "mapDataSourceToMappingWidget",
    value: function mapDataSourceToMappingWidget(loadToEntity, dataFormat, dataSchema, srcColIndex, mappingWidgetIndex, mappingWidgetParamIndex) {
      var mappingWidget = loadToEntity.mappingWidgets[mappingWidgetIndex];

      // Cannot map data source column directly to Map's UDT value.
      if ('valType' in mappingWidget && mappingWidget.valType === 'UDT' && mappingWidgetParamIndex === 1) {
        throw new graphStudioError_model.GraphStudioError("Cannot directly map a column of the data source " + "to a UDT value. Please create a UDT widget first.");
      }
      if (dataFormat === dataSet_interface.DataFormat.JSON) {
        var jsonDatatype = dataSchema[srcColIndex].type;
        switch (jsonDatatype) {
          case dataSet_interface.JSONDataType.Array:
            throw new graphStudioError_model.GraphStudioError("Data mapping from a JSON array to a token function input " + "is currently not supported in TigerGraph.");
          case dataSet_interface.JSONDataType.Object:
            throw new graphStudioError_model.GraphStudioError("Data mapping directly from a JSON object to a token function input is not allowed." + " Please map from its descendant primitive (STRING, NUMBER, BOOLEAN) properties instead.");
          case dataSet_interface.JSONDataType.Null:
            throw new graphStudioError_model.GraphStudioError("Data mapping from a JSON null to to a token function input is not allowed.");
          default:
            break;
        }
      }
      mappingWidget.params[mappingWidgetParamIndex] = {
        sourceType: SourceType.DataSourceColumn,
        index: srcColIndex
      };
    }

    /**
     * Get token function by name.
     *
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "getTokenFunction",
    value: function getTokenFunction(name) {
      return _findInstanceProperty__default["default"](combinedTokenFunctionList).call(combinedTokenFunctionList, function (func) {
        return func.name === name;
      });
    }

    /**
     * Map from one mapping widget output to one column in vertex | edge.
     * Assumptions:
     * 1. mappingWidgetIndex is within mappingWidgets array index boundary
     * 2. mappingsIndex is within vertex | edge mapping array index boundary
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {number} mappingWidgetIndex
     * @param {number} mappingsIndex
     * @param {Graph} schema
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "mapMappingWidgetToEntity",
    value: function mapMappingWidgetToEntity(loadToEntity, mappingWidgetIndex, mappingsIndex, schema) {
      // Save the original mapping
      var originalMapping = loadToEntity.mappings[mappingsIndex];
      // Update to the new mapping
      loadToEntity.mappings[mappingsIndex] = {
        sourceType: SourceType.MappingWidget,
        index: mappingWidgetIndex
      };
      var mappingWidget = loadToEntity.mappingWidgets[mappingWidgetIndex];
      var widgetOutputTypes = [];
      var widgetTypeMessage;
      if ('funcName' in mappingWidget) {
        // Token function
        // Check if the token function exists.
        var tokenFunctionName = mappingWidget.funcName;
        var tokenFunction = this.getTokenFunction(tokenFunctionName);
        if (tokenFunction === undefined) {
          throw new graphStudioError_model.GraphStudioError("Token function ".concat(tokenFunctionName, " ") + "does not exist, maybe it has been removed from GSQL. Please remove it " + "from Data Mapping and use other token functions.");
        }
        widgetOutputTypes = tokenFunction.returnType;
        widgetTypeMessage = "but the token function's output type is ".concat(tokenFunction.returnType[0]);
      } else if ('udtName' in mappingWidget) {
        // UDT
        widgetOutputTypes = [mappingWidget.udtName];
        widgetTypeMessage = "not a UDT ".concat(mappingWidget.udtName);
      } else /* if ('keyType' in mappingWidget) */{
          var _context9;
          // Map
          widgetOutputTypes = [_concatInstanceProperty__default["default"](_context9 = "MAP<".concat(mappingWidget.keyType, ", ")).call(_context9, mappingWidget.valType === 'UDT' ? mappingWidget.udtType : mappingWidget.valType, ">")];
          widgetTypeMessage = "not a ".concat(widgetOutputTypes[0]);
        }

      // If the mapping widget's output type doesn't match target expected type, rollback
      // to original mapping, and hint user the issue
      if ('vertexName' in loadToEntity) {
        // Load to vertex
        var vertex = schema.getVertex(loadToEntity.vertexName);
        if (mappingsIndex === 0 && !_includesInstanceProperty__default["default"](widgetOutputTypes).call(widgetOutputTypes, vertex.primaryId.type.name)) {
          var _context10;
          // primary id data type not match
          loadToEntity.mappings[mappingsIndex] = originalMapping;
          throw new graphStudioError_model.GraphStudioError("Vertex \"".concat(vertex.name, "\"'s primary id expects ") + _concatInstanceProperty__default["default"](_context10 = "a(n) ".concat(vertex.primaryId.type.getValueType(), ", ")).call(_context10, widgetTypeMessage, "."));
        } else if (mappingsIndex > 0 && !_includesInstanceProperty__default["default"](widgetOutputTypes).call(widgetOutputTypes, vertex.attributes[mappingsIndex - 1].type.getValueType())) {
          var _context11;
          // attribute data type not match
          loadToEntity.mappings[mappingsIndex] = originalMapping;
          throw new graphStudioError_model.GraphStudioError("Vertex \"".concat(vertex.name, "\"'s attribute ") + "\"".concat(vertex.attributes[mappingsIndex - 1].name, "\" expects ") + _concatInstanceProperty__default["default"](_context11 = "a(n) ".concat(vertex.attributes[mappingsIndex - 1].type.getValueType(), ", ")).call(_context11, widgetTypeMessage, "."));
        }
      } else /* if ('edgeName' in loadToEntity) */{
          // Load to edge
          var edge = schema.getEdge(loadToEntity.edgeName);
          var fromVertex = schema.getVertex(loadToEntity.fromVertexType);
          var toVertex = schema.getVertex(loadToEntity.toVertexType);
          if (mappingsIndex === 0 && !_includesInstanceProperty__default["default"](widgetOutputTypes).call(widgetOutputTypes, fromVertex.primaryId.type.getValueType())) {
            var _context12, _context13;
            // source vertex primary id not match
            loadToEntity.mappings[mappingsIndex] = originalMapping;
            throw new graphStudioError_model.GraphStudioError(_concatInstanceProperty__default["default"](_context12 = "Edge \"".concat(edge.name, "\"'s source vertex \"")).call(_context12, fromVertex.name, "\"'s primary id ") + _concatInstanceProperty__default["default"](_context13 = "expects a(n) ".concat(fromVertex.primaryId.type.getValueType(), ", ")).call(_context13, widgetTypeMessage, "."));
          } else if (mappingsIndex === 1 && !_includesInstanceProperty__default["default"](widgetOutputTypes).call(widgetOutputTypes, toVertex.primaryId.type.getValueType())) {
            var _context14, _context15;
            // target vertex primary id not match
            loadToEntity.mappings[mappingsIndex] = originalMapping;
            throw new graphStudioError_model.GraphStudioError(_concatInstanceProperty__default["default"](_context14 = "Edge \"".concat(edge.name, "\"'s target vertex \"")).call(_context14, toVertex.name, "\"'s ") + _concatInstanceProperty__default["default"](_context15 = "primary id expects a(n) ".concat(toVertex.primaryId.type.getValueType(), ", ")).call(_context15, widgetTypeMessage, "."));
          } else if (mappingsIndex > 1 && !_includesInstanceProperty__default["default"](widgetOutputTypes).call(widgetOutputTypes, edge.attributes[mappingsIndex - 2].type.getValueType())) {
            var _context16;
            // attribute data type not match
            loadToEntity.mappings[mappingsIndex] = originalMapping;
            throw new graphStudioError_model.GraphStudioError("Edge \"".concat(edge.name, "\"'s attribute ") + "\"".concat(edge.attributes[mappingsIndex - 2].name, "\" expects ") + _concatInstanceProperty__default["default"](_context16 = "a(n) ".concat(edge.attributes[mappingsIndex - 2].type.getValueType(), ", ")).call(_context16, widgetTypeMessage, "."));
          }
        }
    }

    /**
     * Map from one mapping widget output to one input param in another mapping widget.
     * Assumptions:
     * 1. sourceMappingWidgetIndex is within mappingWidgets array index boundary
     * 2. targetMappingWidgetIndex is within mappingWidgets array index boundary
     * 3. targetMappingWidgetParamIndex is within the mapping widget's param array boundary
     *
     * If there is circular mapping widget reference, will raise error and rollback to old mapping.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {number} sourceMappingWidgetIndex
     * @param {number} targetMappingWidgetIndex
     * @param {number} targetMappingWidgetParamIndex
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "mapMappingWidgetToMappingWidget",
    value: function mapMappingWidgetToMappingWidget(loadToEntity, sourceMappingWidgetIndex, targetMappingWidgetIndex, targetMappingWidgetParamIndex) {
      var sourceMappingWidget = loadToEntity.mappingWidgets[sourceMappingWidgetIndex];
      var targetMappingWidget = loadToEntity.mappingWidgets[targetMappingWidgetIndex];
      var sourceWidgetOutputTypes = [];
      var sourceWidgetTypeMessage;
      var targetWidgetInputType;
      var targetWidgetTypeMessage;

      // Set source mapping widget output type and type message.
      if ('funcName' in sourceMappingWidget) {
        var _context17;
        // Source is a token function.
        // Check if source widget token function exists.
        var tokenFunction = this.getTokenFunction(sourceMappingWidget.funcName);
        if (tokenFunction === undefined) {
          throw new graphStudioError_model.GraphStudioError("Token function ".concat(sourceMappingWidget.funcName, " ") + "does not exist, maybe it has been removed from GSQL. Please remove it " + "from Data Mapping and use other token functions.");
        }
        sourceWidgetOutputTypes = tokenFunction.returnType;
        sourceWidgetTypeMessage = _concatInstanceProperty__default["default"](_context17 = "token function \"".concat(tokenFunction.name, "\" with return type ")).call(_context17, sourceWidgetOutputTypes[0]);
      } else if ('udtName' in sourceMappingWidget) {
        // Source is a UDT.
        sourceWidgetOutputTypes = [sourceMappingWidget.udtName];
        sourceWidgetTypeMessage = "UDT ".concat(sourceMappingWidget.udtName);
      } else /* if ('keyType' in sourceMappingWidget) */{
          var _context18;
          // Source is a Map.
          sourceWidgetOutputTypes = [_concatInstanceProperty__default["default"](_context18 = "MAP<".concat(sourceMappingWidget.keyType, ", ")).call(_context18, sourceMappingWidget.valType === 'UDT' ? sourceMappingWidget.udtType : sourceMappingWidget.valType, ">")];
          sourceWidgetTypeMessage = sourceWidgetOutputTypes[0];
        }

      // Set target mapping widget input type and type message.
      if ('funcName' in targetMappingWidget) {
        // Target is a token function.
        targetWidgetInputType = 'STRING';
        targetWidgetTypeMessage = "a token function's input which accept a STRING";
      } else if ('udtName' in targetMappingWidget) {
        // Target is a UDT.
        targetWidgetInputType = targetMappingWidget.udt.fields[targetMappingWidgetParamIndex].fieldType;
        targetWidgetTypeMessage = "a ".concat(targetWidgetInputType, " type UDT field");
      } else /* if ('keyType' in sourceMappingWidget) */{
          // Target is a MAP.
          if (targetMappingWidgetParamIndex === 0) {
            // Map's key
            targetWidgetInputType = targetMappingWidget.keyType;
            targetWidgetTypeMessage = "a map's key with ".concat(targetWidgetInputType, " type");
          } else /* if (targetMappingWidgetParamIndex === 1) */{
              // Map's val
              targetWidgetInputType = targetMappingWidget.valType === 'UDT' ? targetMappingWidget.udtType : targetMappingWidget.valType;
              targetWidgetTypeMessage = "a map's value with ".concat(targetWidgetInputType, " type");
            }
        }

      // If the source output type doesn't match the target input type, report error.
      if (!_includesInstanceProperty__default["default"](sourceWidgetOutputTypes).call(sourceWidgetOutputTypes, targetWidgetInputType)) {
        var _context19;
        throw new graphStudioError_model.GraphStudioError(_concatInstanceProperty__default["default"](_context19 = "Cannot map ".concat(sourceWidgetTypeMessage, " to ")).call(_context19, targetWidgetTypeMessage, "."));
      }

      // Save the original mapping
      var originalMapping = loadToEntity.mappingWidgets[targetMappingWidgetIndex].params[targetMappingWidgetParamIndex];
      // Update to the new mapping
      loadToEntity.mappingWidgets[targetMappingWidgetIndex].params[targetMappingWidgetParamIndex] = {
        sourceType: SourceType.MappingWidget,
        index: sourceMappingWidgetIndex
      };
      // If mapping widget params have circle reference(s), rollback to original mapping, and
      // hint user the issue.
      if (LoadingMappingLogic.mappingWidgetsHasCircularReference(loadToEntity.mappingWidgets, loadToEntity.mappingWidgets[targetMappingWidgetIndex].params[targetMappingWidgetParamIndex], new _Set__default["default"]())) {
        loadToEntity.mappingWidgets[targetMappingWidgetIndex].params[targetMappingWidgetParamIndex] = originalMapping;
        throw new graphStudioError_model.GraphStudioError('Token functions, Map widgets and UDT widgets ' + 'cannot have circular references between each other.');
      }
    }

    /**
     * Remove mappings of given indices. Reset them to be default mapping.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {(OneColumnMappingGraphEntityTarget | OneColumnMappingMappingWidgetTarget)[]} mappingIndicesToBeDeleted
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "removeLoadingMappings",
    value: function removeLoadingMappings(loadToEntity, mappingIndicesToBeDeleted) {
      _forEachInstanceProperty__default["default"](mappingIndicesToBeDeleted).call(mappingIndicesToBeDeleted, function (mappingIndex) {
        if (mappingIndex.type === OneColumnMappingTargetType.GraphEntity) {
          // Remove the mapping from graph entity
          LoadingMappingLogic.mapDefaultToEntity(loadToEntity, mappingIndex.mappingIndex);
        } else /* if (mappingIndex.type === OneColumnMappingTargetType.TokenFunction) */{
            // Remove the mapping from token function paramter
            LoadingMappingLogic.mapDefaultToMappingWidget(loadToEntity, mappingIndex.mappingWidgetIndex, mappingIndex.paramIndex);
          }
      });
    }

    /**
     * Check if mapping widgets have circular references.
     *
     * @private
     * @static
     * @param {((TokenFunction | MapWidget | TupleWidget)[])} mappingWidgets
     * @param {OneColumnMapping} oneColumnMapping
     * @param {Set<number>} mappingWidgetIndices
     * @returns {boolean}
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "mappingWidgetsHasCircularReference",
    value: function mappingWidgetsHasCircularReference(mappingWidgets, oneColumnMapping, mappingWidgetIndices) {
      // Refer back to an already on-traverse-path token function
      if (mappingWidgetIndices.has(oneColumnMapping.index)) {
        return true;
      }
      mappingWidgetIndices.add(oneColumnMapping.index);
      // Recursively check each token function parameter
      for (var i = 0; i < mappingWidgets[oneColumnMapping.index].params.length; i++) {
        var param = mappingWidgets[oneColumnMapping.index].params[i];
        if (param.sourceType === SourceType.MappingWidget) {
          if (LoadingMappingLogic.mappingWidgetsHasCircularReference(mappingWidgets, param, mappingWidgetIndices)) {
            return true;
          }
        }
      }
      mappingWidgetIndices["delete"](oneColumnMapping.index);
      return false;
    }

    /**
     * Add one more token function to the loading statement.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {string} funcName
     * @param {number} paramNumber
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "addTokenFunction",
    value: function addTokenFunction(loadToEntity, funcName, paramNumber) {
      var _context20, _context21;
      var tokenFunction = {
        funcName: funcName,
        params: _mapInstanceProperty__default["default"](_context20 = _fillInstanceProperty__default["default"](_context21 = Array(paramNumber)).call(_context21, 1)).call(_context20, function () {
          return {
            sourceType: SourceType.Default
          };
        })
      };
      loadToEntity.mappingWidgets.push(tokenFunction);
      // Assign a position for new token function
      loadToEntity.style.middlePositions.push(LoadingMappingLogic.newMiddlePosition(loadToEntity.style));
    }

    /**
     * Add one more Map widget to the loading statement.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {string} keyType
     * @param {string} valType
     * @param {string} udtType
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "addMapWidget",
    value: function addMapWidget(loadToEntity, keyType, valType, udtType) {
      var mapWidget = {
        keyType: keyType,
        valType: valType,
        udtType: udtType,
        params: [{
          sourceType: SourceType.Default
        }, {
          sourceType: SourceType.Default
        }]
      };
      loadToEntity.mappingWidgets.push(mapWidget);
      // Assign a position for new Map widget.
      loadToEntity.style.middlePositions.push(LoadingMappingLogic.newMiddlePosition(loadToEntity.style));
    }

    /**
     * Add one more UDT widget to the loading statement.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {string} udtType
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "addTupleWidget",
    value: function addTupleWidget(loadToEntity, gsqlUDT) {
      var _context22;
      var tupleWidget = {
        udtName: gsqlUDT.name,
        udt: gsqlUDT,
        params: _mapInstanceProperty__default["default"](_context22 = gsqlUDT.fields).call(_context22, function (_) {
          return {
            sourceType: SourceType.Default
          };
        })
      };
      loadToEntity.mappingWidgets.push(tupleWidget);
      // Assign a position for new Tuple widget.
      loadToEntity.style.middlePositions.push(LoadingMappingLogic.newMiddlePosition(loadToEntity.style));
    }

    /**
     * Get the position of newly added token function, widget, etc.
     *
     * @private
     * @static
     * @param {DBLoadingStatementStyle} style
     * @returns {DBPositionStyle}
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "newMiddlePosition",
    value: function newMiddlePosition(style) {
      // Put token function in the middle between data source and loading target.
      var x = (style.sourcePosition.x + style.targetPosition.x) / 2.0;
      var y = (style.sourcePosition.y + style.targetPosition.y) / 2.0;

      // If the token function's position overlaps some other token functions, move it down.
      for (var i = 0; i < style.middlePositions.length * 2; i++) {
        var success = true;
        var _iterator5 = _createForOfIteratorHelper(style.middlePositions),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var position = _step5.value;
            if (helperFunctions.HelperFunctions.twoPointsNearEachOther(x, y, position.x, position.y, 150)) {
              success = false;
              break;
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
        if (!success) {
          y += 150;
        } else {
          break;
        }
      }
      return {
        x: x,
        y: y
      };
    }

    /**
     * Remove one mapping widget from the loading statement.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {number} mappingWidgetIndex
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "removeMappingWidget",
    value: function removeMappingWidget(loadToEntity, mappingWidgetIndex) {
      var _context23, _context24, _context26, _context27;
      // All mappings referring to this token function reset to default
      // All mappings referring to afterward token functions reduce the reference index by 1
      _forEachInstanceProperty__default["default"](_context23 = loadToEntity.mappings).call(_context23, function (mapping) {
        if (mapping.sourceType === SourceType.MappingWidget) {
          if (mapping.index === mappingWidgetIndex) {
            mapping.sourceType = SourceType.Default;
          } else if (mapping.index > mappingWidgetIndex) {
            mapping.index--;
          }
        }
      });
      _forEachInstanceProperty__default["default"](_context24 = loadToEntity.mappingWidgets).call(_context24, function (widget) {
        var _context25;
        _forEachInstanceProperty__default["default"](_context25 = widget.params).call(_context25, function (param) {
          if (param.sourceType === SourceType.MappingWidget) {
            if (param.index === mappingWidgetIndex) {
              param.sourceType = SourceType.Default;
            } else if (param.index > mappingWidgetIndex) {
              param.index--;
            }
          }
        });
      });
      // Remove the token function
      _spliceInstanceProperty__default["default"](_context26 = loadToEntity.mappingWidgets).call(_context26, mappingWidgetIndex, 1);
      _spliceInstanceProperty__default["default"](_context27 = loadToEntity.style.middlePositions).call(_context27, mappingWidgetIndex, 1);
    }

    /**
     * Add where clause to the loading statement.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {ConditionJson} exprJson
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "addWhereClause",
    value: function addWhereClause(loadToEntity, exprJson) {
      if (!exprJson || exprJson.type === 'NullCondition') {
        loadToEntity.style.whereClauseJson = undefined;
      } else {
        loadToEntity.style.whereClauseJson = exprJson;
      }
    }

    /**
     * Map from string literal to one column in vertex | edge.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {number} mappingsIndex
     * @param {string} literal
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "mapStringLiteralToEntity",
    value: function mapStringLiteralToEntity(loadToEntity, mappingsIndex, literal) {
      loadToEntity.mappings[mappingsIndex] = {
        sourceType: SourceType.Literal,
        literal: literal
      };
    }

    /**
     * Map from string literal to one input of mapping widget.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {number} mappingWidgetIndex
     * @param {number} mappingWidgetParamIndex
     * @param {string} literal
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "mapStringLiteralToMappingWidget",
    value: function mapStringLiteralToMappingWidget(loadToEntity, mappingWidgetIndex, mappingWidgetParamIndex, literal) {
      loadToEntity.mappingWidgets[mappingWidgetIndex].params[mappingWidgetParamIndex] = {
        sourceType: SourceType.Literal,
        literal: literal
      };
    }

    /**
     * Map from default (no mapping) to one column in vertex | edge.
     * This is used when remove mapping from one column in vertex | edge.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {number} mappingsIndex
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "mapDefaultToEntity",
    value: function mapDefaultToEntity(loadToEntity, mappingsIndex) {
      loadToEntity.mappings[mappingsIndex] = {
        sourceType: SourceType.Default
      };
    }

    /**
     * Map from default (no mapping) to one input of mapping widget.
     * This is used when remove mapping from one input of mapping widget.
     *
     * @static
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {number} mappingWidgetIndex
     * @param {number} mappingWidgetParamIndex
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "mapDefaultToMappingWidget",
    value: function mapDefaultToMappingWidget(loadToEntity, mappingWidgetIndex, mappingWidgetParamIndex) {
      loadToEntity.mappingWidgets[mappingWidgetIndex].params[mappingWidgetParamIndex] = {
        sourceType: SourceType.Default
      };
    }

    /**
     * Build the auto-mapping from data source to graph entity based on name mapping.
     * The auto-mapping depends on name matching (ignore case, ignore any character other than
     * letters and numbers)
     *
     * @static
     * @param {LoadingJobData} loadingJobData
     * @param {(LoadToVertexData | LoadToEdgeData)} loadToEntity
     * @param {DataFormat} dataFormat
     * @param {DataFieldSchema[]} dataSchema
     * @param {Graph} schema
     * @memberof LoadingMappingLogic
     */
  }, {
    key: "autoMapping",
    value: function autoMapping(loadingJobData, loadToEntity, dataFormat, dataSchema, schema) {
      var _this = this;
      var attributeStart = 0;
      var attributes;
      if ('vertexName' in loadToEntity) {
        // Load to vertex

        attributeStart = 1;
        var vertex = schema.getVertex(loadToEntity.vertexName);
        attributes = vertex.attributes;
        // Map primary id
        if (loadToEntity.mappings[0].sourceType === SourceType.Default) {
          var _context28;
          _forEachInstanceProperty__default["default"](_context28 = loadingJobData.dataSet.dataSchema).call(_context28, function (dataField, i) {
            if (helperFunctions.HelperFunctions.removeConcatCharsAndToLowerCase(dataField.name) === helperFunctions.HelperFunctions.removeConcatCharsAndToLowerCase(vertex.primaryId.name)) {
              loadToEntity.mappings[0] = {
                sourceType: SourceType.DataSourceColumn,
                index: i
              };
            }
          });
        }
      } else /* if ('edgeName' in loadToEntity)*/{
          // Load to edge
          attributeStart = 2;
          var edge = schema.getEdge(loadToEntity.edgeName);
          attributes = edge.attributes;
          // Map source vertex type
          if (loadToEntity.mappings[0].sourceType === SourceType.Default) {
            var _context29;
            _forEachInstanceProperty__default["default"](_context29 = loadingJobData.dataSet.dataSchema).call(_context29, function (dataField, i) {
              if (helperFunctions.HelperFunctions.removeConcatCharsAndToLowerCase(dataField.name) === helperFunctions.HelperFunctions.removeConcatCharsAndToLowerCase(loadToEntity.fromVertexType)) {
                loadToEntity.mappings[0] = {
                  sourceType: SourceType.DataSourceColumn,
                  index: i
                };
              }
            });
          }
          // Map target vertex type
          if (loadToEntity.mappings[1].sourceType === SourceType.Default) {
            var _context30;
            _forEachInstanceProperty__default["default"](_context30 = loadingJobData.dataSet.dataSchema).call(_context30, function (dataField, i) {
              if (helperFunctions.HelperFunctions.removeConcatCharsAndToLowerCase(dataField.name) === helperFunctions.HelperFunctions.removeConcatCharsAndToLowerCase(loadToEntity.toVertexType)) {
                loadToEntity.mappings[1] = {
                  sourceType: SourceType.DataSourceColumn,
                  index: i
                };
              }
            });
          }
        }

      // Auto map attributes
      var _loop = function _loop(i) {
        // Skip auto mapping for MAP and UDT type attributes.
        var attributeType;
        var attributeValueType;
        if ('vertexName' in loadToEntity) {
          attributeType = schema.getVertex(loadToEntity.vertexName).attributes[i - attributeStart].type.name;
          attributeValueType = schema.getVertex(loadToEntity.vertexName).attributes[i - attributeStart].type.valueTypeName;
        } else if ('edgeName' in loadToEntity) {
          attributeType = schema.getEdge(loadToEntity.edgeName).attributes[i - attributeStart].type.name;
          attributeValueType = schema.getEdge(loadToEntity.edgeName).attributes[i - attributeStart].type.valueTypeName;
        }
        if (attributeType === 'MAP' || attributeType === 'UDT' || attributeValueType === 'UDT') {
          return 1; // continue
        }
        if (loadToEntity.mappings[i].sourceType === SourceType.Default) {
          var _context31;
          _forEachInstanceProperty__default["default"](_context31 = loadingJobData.dataSet.dataSchema).call(_context31, function (dataField, j) {
            if (helperFunctions.HelperFunctions.removeConcatCharsAndToLowerCase(dataField.name) === helperFunctions.HelperFunctions.removeConcatCharsAndToLowerCase(attributes[i - attributeStart].name)) {
              switch (dataFormat) {
                case dataSet_interface.DataFormat.JSON:
                  if (_this.jsonAndGSQLTypeMatchCheck(dataSchema[j].type, attributes[i - attributeStart].type.getValueType())) {
                    loadToEntity.mappings[i] = {
                      sourceType: SourceType.DataSourceColumn,
                      index: j
                    };
                  }
                  break;
                default:
                  loadToEntity.mappings[i] = {
                    sourceType: SourceType.DataSourceColumn,
                    index: j
                  };
                  break;
              }
            }
          });
        }
      };
      for (var i = attributeStart; i < loadToEntity.mappings.length; i++) {
        if (_loop(i)) continue;
      }
    }
  }]);
}();

exports.LoadingMappingLogic = LoadingMappingLogic;
exports.OneColumnMappingTargetType = OneColumnMappingTargetType;
exports.SourceType = SourceType;
exports.builtinTokenFunctionDocument = builtinTokenFunctionDocument;
exports.builtinTokenFunctionNames = builtinTokenFunctionNames;
exports.builtinTokenFunctionParamNumber = builtinTokenFunctionParamNumber;
exports.builtinTokenFunctionReturnType = builtinTokenFunctionReturnType;
exports.combinedTokenFunctionList = combinedTokenFunctionList;
